import { useState } from 'react'
import { Modal } from 'rsuite'
import ContactUs from '../../resources/images/Contact-Us.png'
import './project-version-styles.less'
import ContactUsWidget from './ContactUsWidget'
export default function ProjectVersion({ termsUrl }) {
  const [isShow, setIsShow] = useState(false)

  return (
    <>
      <div className="project-version-health">
        {/* <Link onClick={() => setIsShow(true)}> */}
        <img
          src={ContactUs}
          alt="Contact Us"
          className="contact-img"
          onClick={() => setIsShow(true)}
          style={{ marginBottom: 5, marginLeft: 10 }}
        />
        {/* <Icon style={{ marginLeft: 10, color: '#2da888' }} icon={'phone-square'} size="3x"></Icon>
        <span style={{ fontSize: '0.5ren', marginLeft: 10, color: '#ffffff' }}>Contact Us</span> */}
        {/* </Link> */}
      </div>
      <div className="project-version-main" style={{ borderTopRightRadius: '5px' }}>
        <div style={{ paddingLeft: 5, paddingRight: 10 }}>
          <span
            aria-hidden="true"
            role="presentation"
            style={{ marginLeft: '5px', marginRight: '5px', color: 'white' }}
          >
            {`${process.env.REACT_APP_BUILD_VERSION}`}
          </span>
        </div>
      </div>
      <Modal
        show={isShow}
        onHide={(e) => {
          setIsShow(false)
        }}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>
            {/* <h3 style={{ color: '#2da888' }}>หากพบปัญหาการใช้งานระบบโปรดติดต่อ ทีมสนับสนุนที่</h3> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContactUsWidget />
        </Modal.Body>
      </Modal>
    </>
  )
}
